module.exports = __webpack_public_path__ + "media/images/agendor-chat-logo-5a70c89b09e297b2142539243eadbb15.png";